import type { DescService } from '@bufbuild/protobuf';
import { Code } from '@grpc-gen/google/rpc/code_pb';

import { GrpcError } from './grpc-error';

export function getMethod<S extends DescService, M extends keyof S['method']>(
  service: S,
  methodName: M,
): S['method'][M] {
  const method = service.methods.find(
    ({ localName }) => localName === methodName,
  );

  if (method === undefined) {
    throw new GrpcError('Method not found', Code.NOT_FOUND);
  }

  return method as S['method'][M]; // TODO need to reconsider typing
}
